import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QuickActionContext = createContext();

export const QuickActionProvider = ({ children }) => {
  const [quickAction, setQuickAction] = useState('new_lot'); // Mantenemos para compatibilidad
  const [quickActions, setQuickActions] = useState(['new_lot', 'new_sale']); // Nuevo estado
  const navigate = useNavigate();

  const toggleQuickAction = (actionId) => {
    setQuickActions(current => {
      if (current.includes(actionId)) {
        const filtered = current.filter(id => id !== actionId);
        // Si se está desactivando la acción actual, cambiar a otra disponible
        if (actionId === quickAction && filtered.length > 0) {
          setQuickAction(filtered[0]);
        }
        return filtered;
      }
      return [...current, actionId];
    });
  };

  const value = {
    // Mantenemos la API original
    quickAction,
    setQuickAction,
    handleQuickAction: () => {
      switch (quickAction) {
        case 'new_lot':
          navigate('/lots/new');
          break;
        case 'new_sale':
          navigate('/sales/new');
          break;
        default:
          console.warn('Unknown quick action:', quickAction);
      }
    },
    // Agregamos las nuevas funcionalidades
    quickActions,
    toggleQuickAction
  };

  return (
    <QuickActionContext.Provider value={value}>
      {children}
    </QuickActionContext.Provider>
  );
};

export const useQuickAction = () => {
  const context = useContext(QuickActionContext);
  if (context === undefined) {
    throw new Error('useQuickAction must be used within a QuickActionProvider');
  }
  return context;
}; 